module.exports = __webpack_public_path__ + "fonts/YogaOT.7e5ca055ccb0abe9a0762838a5b5e8b9.ttf";